<template>
	<ConditionalRenderingField :param="param" :service="service" :action="action" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import AppActionService from '@/utils/AppActionService';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { getServiceAllActions } from '@/store/modules/apps/getters';
import ConditionalRenderingField from './ConditionalRenderingField.vue';
export default {
	name: 'ConditionalRenderingFieldDataProvider',
	props: { param: { type: Object }, service: { type: Object } },
	components: { ConditionalRenderingField },
	computed: {
		...mapGettersShorthand({ getServiceAllActions }),
		action() {
			return this.getActionByKey(AppActionService.getSourceActionOfParam(this.param));
		},
		allActionsOfSelectedApp() {
			return this.getServiceAllActions(this.service.id).actions;
		},
	},
	methods: {
		getActionByKey(actionKey) {
			return this.allActionsOfSelectedApp.find((action) => action.key === actionKey);
		},
	},
};
</script>

<style lang="scss" scoped></style>
